const defaultPageInfo =
  "<i>Use this form to upload documents to your submitted application. Uploaded documents will be added to the case documents and directed to an analyst for review. Please check the correspondence issued for details on what is required for your case.</i>";
const permPageInfo =
  "Use this form to upload documents to your submitted application. Uploaded documents will be added to case documents. Please check the correspondence issued for details on what is required for your case.";

const RequestForReview_uischema = (formId) => {
  const info = formId === "9089" ? permPageInfo : defaultPageInfo;
  return {
    name: "Request for Review",
    pageInfo: {
      text: info,
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          {
            machine_name: "fileType",
            value: "Request for Review",
            widget: "text",
            style: {
              display: "none",
            },
          },
          {
            machine_name: "files",
            widget: "file_upload",
            file_upload: { fileType: "Request for Review" },
            accept_multiple: true,
            required: true,
            validate: ["required", "file_required"],
            checkFilesAdded: true,
            documentAuth: "dh",
          },
          {
            machine_name: "document_description",
            widget: "text",
            label: "Document Description",
            validate: ["required"],
            maxLength: 100,
          },
        ],
      },
    ],
  };
};

export default RequestForReview_uischema;
